import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useEventListener } from '@beef/shop-common';

import { onProductDetailsInstallmentTabClick } from 'store/ProductDetails/common/actions';

export const INSTALLMENT_SLUG = 'content-rassrochka';
/**
 * Компонент создан для прослушивания события click по кликабельным элементам
 * кастомного таба Рассрочка для передачи пушей ЯМ
 * @returns {null}
 */
export const InstallmentCustomTab = () => {
  const dispatch = useDispatch();
  const listener = useCallback(
    // eslint-disable-next-line consistent-return
    (e) => {
      const element = e.target;
      const isAboutProgram = element.classList.contains('about-programs__header');
      const isClosed = !element.classList.contains('is-closed');
      const value = element.innerHTML.trim();

      if (isAboutProgram && isClosed && value) {
        // YM
        dispatch(onProductDetailsInstallmentTabClick(value));
      }
    },
    [dispatch],
  );

  useEventListener('click', listener);

  return null;
};
